(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('orderCustomerService', {
        templateUrl: 'views/components/views/orderCustomerService/orderCustomerService.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'modalService', 'orderCustomerServiceService', 'ieScreenBlockService', function ($stateParams, stateService, utilityService, translateService, modalService, orderCustomerServiceService, ieScreenBlockService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let orderInternalNo = $stateParams.order_internal_no;
            
            var resizing = false;
            var editing = false;

            let translations = {
                error: '',
                ok: ''
            };

            vm.model = {
                orderNoButtons: [
                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('orderhead', { order_internal_no: vm.model.orderInfo.order_internal_no }) }
                ],
                deliveryDateConfirmedButtons: [
                    {
                        id: 'goto',
                        icon: 'fa fa-solid fa-chevron-right',
                        color: 'primary',
                        type: 'primary',
                        onClick: () => {
                            stateService.go('orderdeliveryinfo', {
                                argtype: 'order_internal_no',
                                argvalue: vm.model.orderInfo.order_internal_no
                            });
                        }
                    }
                ],
                communicationConfig: {
                    name: 'ordercustcom',
                    enabled: true,
                    show: true,
                    activate: gridActivate,
                    deactivate: gridDeactivate,
                    function: function (item) {
                        if (item.canActive === true) {
                            item.isActive = !item.isActive;
                        }

                        if (item.item_name === 'resize') {
                            if (item.isActive) {
                                resizing = true;
                            } else {
                                gridColumnResize(vm.model.communicationConfig, vm.model.itemsListCommunications);
                            }
                        }
                    },
                    records: [
                        { item_id: '6', item_name: 'resize', glyph: 'glyphicon-resize-horizontal', color: 'primary', colorActive: 'warning', canActive: true, isActive: false, isIcon: false, enabled: false, show: true },
                        { item_id: '4', item_name: 'toggle', glyph: 'glyphicon-check', color: 'primary', show: false },
                        { item_id: '5', item_name: 'erase', glyph: 'glyphicon-erase', color: 'danger', show: false },
                        { item_id: '99', item_name: 'save', glyph: 'glyphicon-save', color: 'primary', animate: null, isIcon: true, enabled: false, show: true }
                    ]
                },
                orderlineConfig: {
                    name: 'orderline',
                    enabled: true,
                    show: true,
                    activate: gridActivate,
                    deactivate: gridDeactivate,
                    function: function (item) {
                        if (item.canActive === true) {
                            item.isActive = !item.isActive;
                        }
                        if (item.item_name === 'resize') {
                            if (item.isActive) {
                                resizing = true;
                            } else {
                                gridColumnResize(vm.model.orderlineConfig, vm.model.itemsListOrderLines);
                            }
                        }
                    },
                    records: [
                        { item_id: '6', item_name: 'resize', glyph: 'glyphicon-resize-horizontal', color: 'primary', colorActive: 'warning', canActive: true, isActive: false, isIcon: false, enabled: false, show: true },
                        { item_id: '4', item_name: 'toggle', glyph: 'glyphicon-check', color: 'primary', show: false },
                        { item_id: '5', item_name: 'erase', glyph: 'glyphicon-erase', color: 'danger', show: false },
                        { item_id: '99', item_name: 'save', glyph: 'glyphicon-save', color: 'primary', animate: null, isIcon: true, enabled: false, show: true }
                    ]
                },
                consignmentConfig: {
                    name: 'consignment',
                    enabled: true,
                    show: true,
                    activate: gridActivate,
                    deactivate: gridDeactivate,
                    function: function (item) {
                        if (item.canActive === true) {
                            item.isActive = !item.isActive;
                        }
                        if (item.item_name === 'resize') {
                            if (item.isActive) {
                                resizing = true;
                            } else {
                                gridColumnResize(vm.model.consignmentConfig, vm.model.itemsListConsignments);
                            }
                        }
                    },
                    records: [
                        { item_id: '6', item_name: 'resize', glyph: 'glyphicon-resize-horizontal', color: 'primary', colorActive: 'warning', canActive: true, isActive: false, isIcon: false, enabled: false, show: true },
                        { item_id: '4', item_name: 'toggle', glyph: 'glyphicon-check', color: 'primary', show: false },
                        { item_id: '5', item_name: 'erase', glyph: 'glyphicon-erase', color: 'danger', show: false },
                        { item_id: '99', item_name: 'save', glyph: 'glyphicon-save', color: 'primary', animate: null, isIcon: true, enabled: false, show: true }
                    ]
                },
                requisitionConfig: {
                    name: 'requisition',
                    enabled: true,
                    show: true,
                    activate: gridActivate,
                    deactivate: gridDeactivate,
                    function: function (item) {
                        if (item.canActive === true) {
                            item.isActive = !item.isActive;
                        }
                        if (item.item_name === 'resize') {
                            if (item.isActive) {
                                resizing = true;
                            } else {
                                gridColumnResize(vm.model.requisitionConfig, vm.model.itemsListRequisitions);
                            }
                        }
                    },
                    records: [
                        { item_id: '6', item_name: 'resize', glyph: 'glyphicon-resize-horizontal', color: 'primary', colorActive: 'warning', canActive: true, isActive: false, isIcon: false, enabled: false, show: true },
                        { item_id: '4', item_name: 'toggle', glyph: 'glyphicon-check', color: 'primary', show: false },
                        { item_id: '5', item_name: 'erase', glyph: 'glyphicon-erase', color: 'danger', show: false },
                        { item_id: '99', item_name: 'save', glyph: 'glyphicon-save', color: 'primary', animate: null, isIcon: true, enabled: false, show: true }
                    ]
                },
                purchaseLineConfig: {
                    name: 'purchline',
                    enabled: true,
                    show: true,
                    activate: gridActivate,
                    deactivate: gridDeactivate,
                    function: function (item) {
                        if (item.canActive === true) {
                            item.isActive = !item.isActive;
                        }
                        if (item.item_name === 'resize') {
                            if (item.isActive) {
                                resizing = true;
                            } else {
                                gridColumnResize(vm.model.purchaseLineConfig, vm.model.itemsListPurchaseLines);
                            }
                        }
                    },
                    records: [
                        { item_id: '6', item_name: 'resize', glyph: 'glyphicon-resize-horizontal', color: 'primary', colorActive: 'warning', canActive: true, isActive: false, isIcon: false, enabled: false, show: true },
                        { item_id: '4', item_name: 'toggle', glyph: 'glyphicon-check', color: 'primary', show: false },
                        { item_id: '5', item_name: 'erase', glyph: 'glyphicon-erase', color: 'danger', show: false },
                        { item_id: '99', item_name: 'save', glyph: 'glyphicon-save', color: 'primary', animate: null, isIcon: true, enabled: false, show: true }
                    ]
                },
                orderInfo: {},
                itemsListCommunications: [],
                itemsListOrderLines: [],
                itemsListConsignments: [],
                itemsListRequisitions: [],
                itemsListPurchaseLines: [],
                calculatingNewDeliveryDate: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATE SERVICE

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATE SERVICE

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadInfo() {
                vm.model.orderInfo = (await orderCustomerServiceService.getInfo({ order_internal_no: orderInternalNo }))[0];
                
                if (vm.model.orderInfo.show_ordercustcom_section === '1') loadCommunications();
                if (vm.model.orderInfo.show_orderline_section === '1') loadOrderLines();
                if (vm.model.orderInfo.show_consignment_section === '1') loadConsignments();
                if (vm.model.orderInfo.show_requisition_section === '1') loadRequisitions();
                if (vm.model.orderInfo.show_purchline_section === '1') loadPurchaseLines();
            }
            
            async function loadCommunications() {
                if (utilityService.validateParmsValue(vm.model.orderInfo.order_internal_no) !== true) return;

                ieScreenBlockService.start('message');
                ieScreenBlockService.setMessage('Laster informasjon');

                return orderCustomerServiceService.listCommunications({ order_internal_no: vm.model.orderInfo.order_internal_no }).then((list) => {
                    ieScreenBlockService.stop();
                    vm.model.itemsListCommunications = list;
                });
            }
            
            async function loadOrderLines() {
                if (utilityService.validateParmsValue(vm.model.orderInfo.order_internal_no) !== true) return;

                ieScreenBlockService.start('message');
                ieScreenBlockService.setMessage('Laster informasjon');

                return orderCustomerServiceService.listOrderLines({ order_internal_no: vm.model.orderInfo.order_internal_no }).then((list) => {
                    ieScreenBlockService.stop();
                    vm.model.itemsListOrderLines = list;
                });
            }
            
            async function loadConsignments() {
                if (utilityService.validateParmsValue(vm.model.orderInfo.order_internal_no) !== true) return;

                ieScreenBlockService.start('message');
                ieScreenBlockService.setMessage('Laster informasjon');

                return orderCustomerServiceService.listConsignments({ order_internal_no: vm.model.orderInfo.order_internal_no }).then((list) => {
                    ieScreenBlockService.stop();
                    vm.model.itemsListConsignments = list;
                });
            }
            
            async function loadRequisitions() {
                if (utilityService.validateParmsValue(vm.model.orderInfo.order_internal_no) !== true) return;

                ieScreenBlockService.start('message');
                ieScreenBlockService.setMessage('Laster informasjon');

                return orderCustomerServiceService.listRequisitions({ order_internal_no: vm.model.orderInfo.order_internal_no }).then((list) => {
                    ieScreenBlockService.stop();
                    vm.model.itemsListRequisitions = list;
                });
            }
            
            async function loadPurchaseLines() {
                if (utilityService.validateParmsValue(vm.model.orderInfo.order_internal_no) !== true) return;

                ieScreenBlockService.start('message');
                ieScreenBlockService.setMessage('Laster informasjon');

                return orderCustomerServiceService.listPurchaseLines({ order_internal_no: vm.model.orderInfo.order_internal_no }).then((list) => {
                    ieScreenBlockService.stop();
                    vm.model.itemsListPurchaseLines = list;
                });
            }

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region RESIZE GRID COLUMN FUNCTIONS

            function gridActivate(item) {}
            function gridDeactivate(item) {}
            
            function gridColumnResize(modelConfig, modelArray) {
                for (let m = 0; m < modelConfig.records.length; m++) {
                    if (modelConfig.records[m] && modelConfig.records[m].item_id === '99') {
                        modelConfig.records[m].animate = true;
                        break;
                    }
                }
                
                let updateList = [];
                
                if (modelArray[0] && modelArray[0].item_secondary) {
                    for (let r = 0; r < modelArray[0].item_secondary.length; r++) {
                        if (r === 0) {
                            updateList.push({ item_id: r, item_col_width: modelArray[0].item_col_width })
                        }

                        if (modelArray[0].item_secondary[r]) {
                            updateList.push({ item_id: r + 1, item_col_width: modelArray[0].item_secondary[r].item_col_width })
                        }
                    }
                }
                
                orderCustomerServiceService.updateColumnResize({
                    view_id: 'ordercustomerservice_' + modelConfig.name + '_list',
                    records: updateList
                }).then((response) => {
                    if (response[0] && response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: function (dialogItself) {
                                    dialogItself.close();
                                }
                            }]
                        });
                    } else {
                        for (let m = 0; m < modelConfig.records.length; m++) {
                            if (modelConfig.records[m] && modelConfig.records[m].item_id === '99') {
                                modelConfig.records[m].animate = false;
                                break;
                            }
                        }

                        setTimeout(() => modelConfig.records[m].animate = null, 2000);
                    }
    
                    resizing = false;
                });
            }

            // #endregion RESIZE GRID COLUMN FUNCTIONS

            // #region WINDOW OPEN FUNCTION

            function openUrl(url) {
                let tab = window.open('_blank'); 
                tab.location = url;
            }

            vm.consignmentClick = function (item) {
                let baseItem = item?.item ? item.item : item;

                if (baseItem.item_id !== '0') {
                    if (baseItem.item_glyphicon_color !== 'grey') openUrl(baseItem.item_tracking_url);
                }
            };

            // #endregion WINDOW OPEN FUNCTION

            // #region CALCULATE BUTTON FUNCTION
            
            vm.calculateNewDeliveryDate = function () {
                vm.model.calculatingNewDeliveryDate = true;
                
                orderCustomerServiceService.calculateDeliveryDate({ order_internal_no: vm.model.orderInfo.order_internal_no }).then(() => {
                    vm.model.calculatingNewDeliveryDate = false;
                    loadInfo();
                }, () => vm.model.calculatingNewDeliveryDate = false);
            };
            
            // #endregion CALCULATE BUTTON FUNCTION

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                translate();
                loadInfo();
            };

            // #endregion ON INIT FUNCTION

        }]
    });
})();
